export default "__VITE_ASSET__DzT8pcs5__";